import type { ApiResponse, PageContent } from "src/api/common/apiTypes";
import type { FaqItem } from "src/store/faq";
import { axiosInstance } from "src/api/axiosInstance";
import type { FaqUpsertPayload } from "src/components/faq/FaqUpsertDialog";

export type GetFaqParams = {
  page: number; // 0-based
  size: number;
  order: string;
};

// LIST
export const getFaqListApi = async (
  params: GetFaqParams
): Promise<ApiResponse<PageContent<FaqItem>>> => {
  const res = await axiosInstance.get<ApiResponse<PageContent<FaqItem>>>("/v1/admin/faq/list", {
    params,
  });
  return res.data;
};

// CREATE
export const createFaqApi = async (payload: FaqUpsertPayload): Promise<ApiResponse<FaqItem>> => {
  const res = await axiosInstance.post<ApiResponse<FaqItem>>("/v1/admin/faq", payload);
  return res.data;
};

// UPDATE (path param)
export const updateFaqApi = async (payload: FaqUpsertPayload): Promise<ApiResponse<FaqItem>> => {
  if (!payload.faqId) throw new Error("faqId is required for update");

  const { faqId, ...body } = payload as any;

  const res = await axiosInstance.put<ApiResponse<FaqItem>>(`/v1/admin/faq/${faqId}`, body);
  return res.data;
};

// DELETE (path param)
export const deleteFaqApi = async (payload: { faqId: number }): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`/v1/admin/faq/${payload.faqId}`);
  return res.data;
};
